import type { ReactNode } from 'react';
import { WindowFrame } from '../../components/window';
import type { SettingsTabDef, SettingsViewProps } from './types';
import { GameTabInterface } from './tabs/GameTab';
import { ControlsTabInterface } from './tabs/ControlsTab';
import { HudTabInterface } from './tabs/HudTab';
import './styles.css';

const TABS: SettingsTabDef[] = [
  { id: 'game', label: 'Game' },
  { id: 'controls', label: 'Controls' },
  { id: 'hud', label: 'HUD' },
];

/**
 * Pure UI: settings window chrome, tab bar, and active panel.
 * No game engine calls — all actions come via props from Container.
 */
export function SettingsInterface(props: SettingsViewProps) {
  const { zIndex, onClose, onFocus, gameTools, activeTab, onTabChange } = props;

  let body: ReactNode;
  if (activeTab === 'game') {
    body = <GameTabInterface {...gameTools} />;
  } else if (activeTab === 'controls') {
    body = <ControlsTabInterface />;
  } else {
    body = <HudTabInterface />;
  }

  return (
    <WindowFrame
      title="SETTINGS"
      windowId="arcade-settings"
      zIndex={zIndex}
      theme="dark"
      sizePreset="md"
      onClose={onClose}
      onFocus={onFocus}
      className="settings-window-frame"
      contentClassName="settings-window-content"
    >
      <div className="settings-shell" onMouseDown={(e) => e.stopPropagation()}>
        <div className="settings-tabs" role="tablist" aria-label="Settings sections">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={activeTab === t.id}
              className={activeTab === t.id ? 'settings-tab settings-tab--active' : 'settings-tab'}
              onClick={() => onTabChange(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div className="settings-panel" role="tabpanel">
          {body}
        </div>
      </div>
    </WindowFrame>
  );
}
